<div class="pop-up-custom">
  <!-- <div class="pos-btn-close">
    <button mat-flat-button class="btn-close" (click)="onClose()">
      <mat-icon>clear</mat-icon>
    </button>
  </div> -->
  <div class="w-100 text-center">
    
    <div mat-dialog-title >
      <h1 class="text-file-popup">LUPA PASSWORD</h1>
    </div>
    <div mat-dialog-content class="contentLupaPassword">
      <div class="mt-20 bullets-number">
        <p class="titleNumbering text-left">Jika bapak/ibu tidak bisa login, hal ini disebabkan oleh 2 hal:</p>
        <ol>
          <li>Status keagenan sudah tidak aktif lagi (Terminated)</li>
          <li>Kode akses atau password salah</li>
          <li>Lisensi sudah kadaluarsa</li>
        </ol>
      </div>
      <div class="mt-20 bullets-number">
        <p class="titleNumbering text-left">Untuk mendapatkan password baru dapat dilakukan dengan 2 cara:</p>
        <ol>
          <li>Meminta leader untuk membuat password baru</li>
          <li>Meminta Agency Departement untuk membuat password baru.</li>
        </ol>
        <p class="titleNumbering text-left">Untuk kode akses, gunakan kode agen yang diberikan pada saat mendaftar menjadi agen.</p>
      </div>

    </div>
    <div mat-dialog-actions class="content-button">
      <!-- <div class="w-100">
        <p>Page:</p> 
      </div> -->
      <div class="flex-col50">
        <button  mat-raised-button class="col-50-btn btn-popup" (click)="onClose()">Tutup</button>
      </div>
    </div>
  </div>
</div>

